import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';

@Component({
  selector: 'sgt-input-search',
  templateUrl: './input-search.component.html',
  styleUrls: ['./input-search.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputSearchComponent),
      multi: true,
    },
  ],
})
export class InputSearchComponent extends CustomControlValueAccessor<string> implements OnInit, OnDestroy {
  @ViewChild('searchInput', { static: true }) searchInputRef: ElementRef<HTMLInputElement>;

  @Input() placeholder = 'Pesquisar...';
  @Input() required = false;
  @Input() debounce = 300;
  @Input() minLength = 0;
  @Input() maxLength: number | null = null;
  @Input() focusable = true;
  @Output() searched = new EventEmitter<string>();

  inputValue = '';

  private searchSubject = new Subject<string>();
  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    this.searchSubject
      .pipe(
        debounceTime(this.debounce),
        distinctUntilChanged(),
        takeUntil(this.destroy$)
      )
      .subscribe((text) => {
        this.emitChange(text);
        this.searched.emit(text);
      });
  }

  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.inputValue = input.value;
    this.markAsTouched();

    if (this.inputValue.length >= this.minLength) {
      this.searchSubject.next(this.inputValue);
    }
  }

  clear(): void {
    this.inputValue = '';
    this.emitChange('');
    this.markAsTouched();
    this.searched.emit('');
    this.focus();
  }

  focus(): void {
    if (this.searchInputRef) {
      this.searchInputRef.nativeElement.focus({ preventScroll: true });
    }
  }

  protected updateValue(value: string | null): void {
    this.inputValue = value || '';
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
